var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-btn',{staticClass:"btn-seven-club-plus",attrs:{"depressed":"","large":"","dark":"","rounded":"","height":"48px"},on:{"click":_vm.goTo7ClubPlus}},[_c('span',[_vm._v(" สมัครสมาชิก 7Club+ ")])])
}
var staticRenderFns = []

export { render, staticRenderFns }